export default "__VITE_ASSET__Cjxv$M8t__"